module.exports = __webpack_public_path__ + "e1a7172744f73dc15d9eb9c57c034786.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/piano/9_G#2.mp3
// module id = 106
// module chunks = 0